import React, { useState } from 'react'
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import useDarkMode from 'src/hooks/useDarkMode';

export default function Switcher() {

    const [colorTheme, setTheme] = useDarkMode();
  const [darkSide, setDarkSide] = useState(
    colorTheme === "light" ? true : false
  );

  const toggleDarkMode = (checked) => {
    setTheme(colorTheme);
    setDarkSide(checked);
  };

    return (
        <div>
        <DarkModeSwitch
        className="hover:scale-105 transition-all duration-200"
        moonColor="#282899"
        sunColor="#22D7FF"
        style={{ marginBottom: "0" }}
        checked={darkSide}
        onChange={toggleDarkMode}
        size={22}
      />
        </div>
    )
}
